// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__1sutn","pageHeader":"Settings_pageHeader__-Romi","menu":"Settings_menu__2JMG1","viewOn":"Settings_viewOn__1xT76"};